import React, { useEffect, useState } from 'react';
import moment from 'moment';

import { NAKED_NEWS_LIVE_SCHEDULE } from '../../constants/apiUrls/apiUrls';
import defaultImage from '../../assets/modal/FanZone-Generic.jpg';
import callApi from '../../utils/callApi';


function NNLiveSchedule(props) {
  const [data, setData] = useState([]);

  useEffect(() => {
    callApi(NAKED_NEWS_LIVE_SCHEDULE, 'get').
      then((res) => {
        setData(res.data);
        props.setNakedNewsLivePageAd(res.data[0]);
      }).
      catch(() =>
        setData([])
      );
  }, []);

  return (
    <div className="naked-news-live-bio">
      <div className="left-header">
        Upcoming Live Shows
      </div>
      <div className="schedule-naked-news-live">
        <ul className="schedule-list">
          {
            data.map((val) => (
              <li
                key={val.name}
                className="list-unstyled schedule-list-item"
              >
                <a className="scheduled-profile-img" href={val.profileUrl} rel="noreferrer" target="_blank">
                  <img
                    alt={val.name}
                    src={val.image || val.fallbackImage || defaultImage}
                  />
                </a>
                <div className="scheduled-info">
                  <div className="temptation-name">
                    {val.name || val.nickname}
                  </div>
                  <div className="date">
                    {`${moment(val.dateOfEvent).format('ddd MMM DD hA')} ${val.timezone}`}
                  </div>
                </div>
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
}

export default NNLiveSchedule;
